import {  GawdsContractFactory } from 'web/lib/contract'
import useSWR from 'swr'
import { CacheKey } from 'web/lib/cache-keys'
import { BloodShop } from 'web/types/ethers-contracts'
import { Boon } from 'web/lib/boon'
import { ethers } from 'ethers'

const useBoonPrice = (boon: Boon): number => {
  const shopContract = GawdsContractFactory.get("BloodShop") as BloodShop

  const { data } = useSWR(CacheKey.boonPrice(boon.id), async () => {
    const price = ethers.utils.formatEther(await shopContract.getBoonPrice(boon.id))
    return parseInt(price)
  }, {
    refreshInterval: 1000 * 3600 * 12, // 12 hrs
  })

  return data || boon.price
}

export default useBoonPrice;